import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, TreeNode, Message } from 'primeng/api';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { User, UserService } from 'src/app/core';
import { FAZILService } from 'src/app/core/services/fazil.service';
import { UIService } from 'src/app/core/services/ui.service';
import { CatalogoModel } from 'src/app/modelo/Catalogo.model';
import { EliminarData } from 'src/app/modelo/EliminarData';
import { TareaModel } from 'src/app/modelo/Tarea.model';
import { UsuarioModel } from 'src/app/modelo/usuario.model';
import { environment } from 'src/environments/environment';
import { AdministracionService } from '../administracion.service';

@Component({
    selector: 'app-admin-catalogos',
    templateUrl: './admin-catalogos.component.html',
    styleUrls: ['./admin-catalogos.component.scss']
})
export class AdminCatalogosComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    catalogos: CatalogoModel[] = [];
    catalogosSeleccionados: CatalogoModel[] = [];
    catalogosFiltrados: CatalogoModel[] = [];
    catalogo: CatalogoModel = new CatalogoModel();
    grupo: CatalogoModel = new CatalogoModel();
    catalogosTree: TreeNode[] = [];
    catalogosTreeNodos: TreeNode[] = [];
    eliminarData: EliminarData;

    //Catálogos

    //Variables auxiliares
    mostrarEditor: boolean = false;
    cols: any[];
    multiSortMeta = [];
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    ui: UIService;

    constructor(
        private router: Router,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private administracionService: AdministracionService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();
    }


    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.breadcrumbService.setItems([
            { label: 'Administración de Catálogos', routerLink: ['administracion/catalogos'] }
        ]);
        this.cols = [
            { field: 'nombre', header: 'Nombre', visible: true },
            { field: 'descripcion', header: 'Descripción', visible: true },
            { field: 'fecha', header: 'Fecha de modificación', visible: true },
            { field: 'id', header: 'Id', visible: false },
        ];
        this.multiSortMeta.push({ field: 'nombre', order: 1 });
    }


    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                this.cargarDataInit();
            }
        });
    }

    async cargarDataInit() {
        this.catalogos = await this.administracionService.getCatalogosActivosData();
        this.catalogosTree = await this.administracionService.getCatalogosArbolData();
        this.cargandoDataInit = false;
    }

    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.catalogosTreeNodos = [];
        this.grupo = new CatalogoModel();
        this.catalogo = new CatalogoModel();
        this.catalogo.orden = this.catalogos.length; //El último de la lista
    }


    nuevoCatalogo(): void {
        this.resetVariables();
        this.mostrarEditor = true;
    }

    agregarCatalogo(node: TreeNode): void {
        this.resetVariables();
        this.grupo = this.catalogos.find((item) => item.id == node['id']);
        this.mostrarEditor = true;
    }

    editarCatalogo(node: TreeNode): void {
        this.resetVariables();
        this.administracionService.getCatalogo(node['uuid']).subscribe(data => {
            this.catalogo = data;
            this.grupo = this.catalogos.find((item) => item.id == this.catalogo.catalogoId) ? this.catalogos.find((item) => item.id == this.catalogo.catalogoId) : new CatalogoModel();
            this.mostrarEditor = true;
        });
    }

    formPrincipalCompleto() {
        return true;
    }

    guardarCatalogo(): void {
        this.ui.limpiarMessages();
        if (!this.formPrincipalCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            if (this.grupo && this.grupo.id) {
                this.catalogo.catalogoId = this.grupo.id;
            } else {
                this.catalogo.catalogoId = null;
            }
            this.administracionService.guardarCatalogo(this.catalogo).subscribe(
                async (data) => {
                    this.catalogo = data;
                    this.catalogos = await this.administracionService.getCatalogosActivosData();
                    this.catalogosTree = await this.administracionService.getCatalogosArbolData();
                    this.ui.mostrarMensaje("success", `Actualización del catálogo ${this.catalogo.name} se realizó con éxito.`);
                    this.mostrarEditor = false;
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    confirmarBorrarCatalogo(nd: TreeNode): void {
        this.resetVariables();
        let node = nd['node'];
        if (node['data']['type'] == 'root') {
            this.confirmationService.confirm({
                message: "Este catálogo tiene catálogos inferiores que también se borrarán." +
                    "¿Está seguro de eliminar el catálogo <strong>" + node['data']['nombre'] + "</strong> y sus inferiores ?. No será posible recuperar la información.",
                accept: () => {
                    this.catalogosTreeNodos = this.ui.addNodesToArray(node, 'uuid');
                    this.borrarCatalogos();
                },
            });
        } else {
            this.confirmationService.confirm({
                message: "¿Está seguro de eliminar el catálogo <strong>" + node['data']['nombre'] + "</strong>?. No será posible recuperar la información.",
                accept: () => {
                    this.borrarCatalogo(node);
                },
            });
        }
    }

    borrarCatalogo(node: TreeNode): void {
        this.administracionService.borrarCatalogo(node['data']['uuid']).subscribe(
            async (data) => {
                this.catalogos = await this.administracionService.getCatalogosActivosData();
                this.catalogosTree = await this.administracionService.getCatalogosArbolData();
                this.ui.mostrarMensaje("success", `El catálogo ${node['data']['nombre']} ha sido eliminado con éxito.`);
            },
            (err) => {
                this.ui.mostrarError(err);
            }
        );
    }


    public confirmarBorrarSeleccionados(): void {
        this.ui.limpiarMessages();
        this.confirmationService.confirm({
            message: "¿Está seguro de eliminar los catálogoso seleccionados?. No será posible recuperar la información.",
            accept: () => {
                this.borrarCatalogos();
            },
        });
    }

    private borrarCatalogos(): void {
        this.eliminarData = new EliminarData();
        if (this.catalogosTreeNodos && this.catalogosTreeNodos.length) {
            this.eliminarData.uuids = this.catalogosTreeNodos.map(function(obj) {
                return obj.data ? obj.data['uuid'] : obj['uuid'];
            });
            this.administracionService.borrarCatalogos(this.eliminarData).subscribe(
                async (data) => {
                    this.catalogos = await this.administracionService.getCatalogosActivosData();
                    this.catalogosTree = await this.administracionService.getCatalogosArbolData();
                    this.catalogosSeleccionados = [];
                    this.ui.mostrarMensaje("success", `Los catálogos seleccionados han sido eliminados con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        } else {
            this.ui.mostrarMensaje("warn", `No se han seleccionado catálogos para su eliminación.`);
        }
    }

    /**
    ** Métodos de formulario
    **/
    filtrarCatalogos(event) {
        const filtered: any[] = [];
        const query = event.query;
        for (let i = 0; i < this.catalogos.length; i++) {
            const catalogo = this.catalogos[i];
            if (catalogo.name.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                filtered.push(catalogo);
            }
        }
        this.catalogosFiltrados = filtered;
    }

    ///////////////////////////////////////////////////////////////////////////
    //Control de acceso a acciones en pantalla
    // TODO: implementar estos métodos en todas las pantallas
    ///////////////////////////////////////////////////////////////////////////
    puedeEjecutar(accion: string): boolean {
        if (!this.currentUser || !this.currentUser.tareas) { //No tiene esta tarea
            return false;
        }

        const routerLink = this.router.url.replace("/fazil/", "");
        let tarea: TareaModel = new TareaModel;
        tarea = this.currentUser.tareas.find(val => routerLink.startsWith(val.routerLink));

        if (!tarea) { //No tiene esta tarea
            return false;
        }
        if (accion == "lectura") {
            return tarea.puedeLeer;
        } else if (accion == "crear") {
            return tarea.puedeCrear;
        } else if (accion == "escritura") {
            return tarea.puedeEscribir;
        } else if (accion == "borrado") {
            return tarea.puedeBorrar;
        } else if (accion == "aprobar") {
            return tarea.puedeAprobar;
        }
        return false;
    }

    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    getTareasPermisos(routeLink: string): Promise<any> {
        return this.fazilService.getTareasPermisos(routeLink).toPromise();
    }

}
